import React, { useContext } from "react";
import { Link, NavLink } from "react-router-dom";

import '../../assets/FrontEnd/css/font.css';
import '../../assets/FrontEnd/plugins/bootstrap/css/bootstrap.min.css';
import '../../assets/FrontEnd/css/font-awesome/font-awesome.min.css';
import '../../assets/FrontEnd/css/magnific-popup.min.css';
import '../../assets/FrontEnd/plugins/owlcarousel/owl.carousel.min.css';
import '../../assets/FrontEnd/plugins/owlcarousel/owl.theme.default.min.css';
import '../../assets/FrontEnd/css/style.css';
import '../../assets/FrontEnd/js/toaster/toastr.min.css';
import '../../assets/FrontEnd/css/fancybox/fancybox-v4-0-27.css';

import MailLogo from '../../assets/images/logo.png';
import { AuthContext } from "../../constants/AuthContext";

const FrontEndHeader = () => {
  const { authUser } = useContext(AuthContext);
  return (
    <>
      <header className="main-header">
        <div className="container">
          <nav className="navbar navbar-expand-lg header-nav">
            {/* Logo */}
            <div className="navbar-header" style={{ margin: "0" }}>
              <Link to="/" className="navbar-brand logo">
                <img src={MailLogo} alt="Logo" height={40} width={40} />
              </Link>
            </div>

            {/* Main Menu */}
            <div className="main-menu-wrapper">
              <div className="menu-header">
                <Link to="/" className="navbar-brand logo">
                  <img src={MailLogo} alt="Logo" height={20} width={20} />
                </Link>
                <button id="menu_close" className="menu-close shadow">
                  <i className="far fa-times"></i>
                </button>
              </div>
            </div>

            {/* Right Side */}
            <ul className="d-flex align-items-center gap-sm-3 gap-2">

              {authUser == null ? (
                <li className="user-img border-0 d-block d-lg-block">
                  <Link to="/login">
                    <div className="btn-user bg-dark">
                      <i className="fa-regular fa-user"></i>
                    </div>
                  </Link>
                </li>
              ) : (
                <>
                  {authUser?.user_type == 'D' ? (
                    <li className="d-block d-lg-block">
                      <Link to="/create-booking" className="btn btn-primary">
                        Create a Booking
                      </Link>
                    </li>
                  ) : null}
                  <li>
                    <Link to="/profile">
                      <img
                        className="user-img border-0 header-profile-user shadow"
                        src={authUser?.profile_pic}
                        alt="Avatar"
                        style={{ width: "40px", height: "40px", objectFit: "cover" }}
                      />
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
};

export default FrontEndHeader;
